import React, { Component } from "react";
import { Input, Checkbox, Select, InputNumber } from "antd";
import { COLORS } from "../../pages/theme";
import Form from "./form";
import { typeRepresentation } from "../util";
import { CustomSwitch } from "../../components/basic_items";
import { JsonEditor as Editor } from "jsoneditor-react";
import "jsoneditor-react/es/editor.min.css";

import ace from "brace";
import "brace/mode/json";
import "brace/theme/tomorrow_night_blue";

// validation": {
// #                 "type": "FK",
// #                 "reference": "Api",
// #                 "required": True,
//         "validate_fk": "false",
//         "send_params": True,
//         "url": "/apis"
// #             }

let choice_options = [
  { text: "String", value: "string" },
  { text: "Integer", value: "integer" },
  { text: "Decimal", value: "decimal" },
];
const type_options = [
  { text: "String", value: "string" },
  { text: "Integer", value: "integer" },
  { text: "Boolean", value: "boolean" },
  { text: "Decimal", value: "decimal" },
  { text: "DateTime", value: "datetime" },
  { text: "Date", value: "date" },
  { text: "List", value: "list" },
  { text: "Foreign Table", value: "FK" },
  { text: "Json Data", value: "jsondata" },
  { text: "Choice", value: "choice" },
  { text: "Select", value: "select" },
];

let static_option_keys = [
  "required",
  "type",
  "default",
  "format",
  "validate_fk",
  "send_params",
  "url",
  "length",
  "strip",
  "choice_type",
  "choices",
  "list_type",
  "conditional",
  "schema_options",
];
let schema_field = [
  {
    index: "schema",
    name: "Schema:",
    type: "complexconfig",
    multiple: true,
    count: 1,
    required: true,
    isDraggable: true,
  },
];

let choice_fields = ({ choice_type }) => [
  {
    index: "choices",
    name: "Choices:",
    type: typeRepresentation(choice_type),
    multiple: true,
    count: 1,
    required: true,
    isDraggable: true,
  },
];

let string_option_field = ({}) => [
  {
    index: "options",
    name: "Options",
    type: "form",
    multiple: true,
    isHorizontal: true,
    isDraggable: true,
    count: 1,
    schema: [
      {
        index: "text",
        name: "Text",
        type: "text",
      },
      {
        index: "value",
        name: "Value",
        type: "text",
      },
    ],
  },
];
let fk_extra_fields = [
  {
    index: "extras",
    name: "Extra Validations",
    type: "json",
  },
];

let conditional_field = ({ type, max }) => [
  {
    index: "schema_options_array",
    name: "Conditional Schemas",
    type: "form",
    multiple: true,
    isHorizontal: true,
    isDraggable: true,
    count: 1,
    max: max,
    childrenStyle: {
      padding: 8,
      border: `1px solid ${COLORS.border_basic}`,
      borderRadius: 10,
      margin: 4,
    },
    schema: [
      {
        index: "value",
        name: "Value",
        type: typeRepresentation(type),
        style: {
          width: 200,
        },
      },
      {
        index: "schema",
        name: "Schema:",
        type: "complexconfig",
        multiple: true,
        isDraggable: true,
        count: 1,
        required: true,
        style: {
          flex: 1,
        },
      },
    ],
  },
];
class ComplexConfigForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit_mode: "UI",
    };
  }

  _renderFormItem = (item) => {
    let _data = this.props.value || {};
    let validation = _data.validation || {};

    switch (item.type) {
      case "text":
        return (
          <Input
            style={{ width: 200 }}
            value={validation[item.index]}
            onChange={(e) => {
              this.props.onChange({
                ..._data,
                validation: {
                  ...validation,
                  [item.index]: e.target.value,
                },
              });
            }}
            placeholder={item.name}
          />
        );
      case "number":
        return (
          <InputNumber
            style={{
              width: 200,
            }}
            name={item.index}
            placeholder={item.name}
            value={validation[item.index]}
            onChange={(value) => {
              this.props.onChange({
                ..._data,
                validation: {
                  ...validation,
                  [item.index]: value,
                },
              });
            }}
          />
        );
      default:
        return <div>Render not defined for {item.type}</div>;
    }
  };

  render() {
    // console.log("value is", this.props)
    let data = this.props.value || {};
    let validation = data.validation || {};
    let length = validation.length || {};
    let schema_options = validation.schema_options || {};
    let extra_data = {};
    let extra_fields = this.props.extra_fields || [];
    Object.keys(validation).map((key_name) => {
      // console.log("static keys", static_option_keys)
      if (!static_option_keys.includes(key_name)) {
        extra_data[key_name] = validation[key_name];
      }
    });
    let schema_options_array = Object.keys(schema_options).map((key) => {
      return { value: key, schema: schema_options[key] };
    });

    if (validation.required == null) {
      this.props.onChange({
        ...data,
        validation: {
          ...validation,
          required: false,
        },
      });
    }

    return (
      <div
        style={{
          width: "100%",
        }}
      >
        {this.props.toggle_ui_json && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              position: "relative",
              alignItems: "center",
              height: 25,
            }}
          >
            <div className="hoverable-switch hand-cursor">
              <CustomSwitch
                className="hoverable-switch-child"
                title="Switch between JSON Editor and UI Editor"
                value={this.state.edit_mode}
                trueItem="UI"
                falseItem="JSON EDITOR"
                onChange={(value) => {
                  this.setState({
                    edit_mode: value,
                  });
                }}
              />
            </div>
          </div>
        )}
        {this.state.edit_mode === "UI" ? (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              // justifyContent: 'space-between',
              flexWrap: "wrap",
              alignItems: "center",
              padding: 4,
              borderBottom: `1px solid ${COLORS.border_basic}`,
            }}
          >
            <div
              className="complex-item-hor"
              style={{
                flex: 1,
                minWidth: "50%",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                paddingRight: 6,
                marginBottom: 8,
              }}
            >
              <span
                style={{
                  width: 100,
                }}
              >
                Name:
              </span>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <Input
                style={{ width: 200 }}
                value={data.name}
                onChange={(e) => {
                  this.props.onChange({
                    ...data,
                    name: e.target.value,
                  });
                }}
                placeholder="Name"
              />
            </div>
            <div
              className="complex-item-hor"
              style={{
                flex: 1,
                minWidth: "50%",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                paddingRight: 6,
                marginBottom: 8,
              }}
            >
              <span
                style={{
                  width: 100,
                }}
              >
                Display Name:
              </span>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <Input
                style={{ width: 200 }}
                value={data.display_name}
                onChange={(e) => {
                  this.props.onChange({
                    ...data,
                    display_name: e.target.value,
                  });
                }}
                placeholder="Display Name"
              />
            </div>
            {this.props.activity_table_upload_file && (
              <div
                className="complex-item-hor"
                style={{
                  flex: 1,
                  minWidth: "50%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingRight: 6,
                  marginBottom: 8,
                }}
              >
                <span
                  style={{
                    width: 100,
                  }}
                >
                  Column:
                </span>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Input
                  style={{ width: 200 }}
                  value={data.column}
                  onChange={(e) => {
                    this.props.onChange({
                      ...data,
                      column: e.target.value,
                    });
                  }}
                  placeholder="Column"
                />
              </div>
            )}
            <div
              className="complex-item-hor"
              style={{
                flex: 1,
                minWidth: "50%",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                paddingRight: 6,
                marginBottom: 8,
              }}
            >
              <span
                style={{
                  width: 100,
                }}
              >
                Required:
              </span>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <Checkbox
                checked={validation.required}
                onChange={(e) => {
                  this.props.onChange({
                    ...data,
                    validation: {
                      ...validation,
                      required: e.target.checked,
                    },
                  });
                }}
              />
            </div>
            <div
              className="complex-item-hor"
              style={{
                flex: 1,
                // minWidth: 300,
                minWidth: "50%",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                paddingRight: 6,
                marginBottom: 8,
              }}
            >
              <span
                style={{
                  width: 100,
                }}
              >
                Type:
              </span>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <Select
                style={{
                  width: 200,
                }}
                disabled={data.name == null || data.name == ""}
                placeholder="Type"
                value={validation.type}
                onChange={(value) => {
                  this.props.onChange({
                    ...data,
                    validation: {
                      ...validation,
                      type: value,
                    },
                  });
                }}
              >
                {type_options.map((item) => {
                  return (
                    <Select.Option key={item.value} value={item.value}>
                      {item.text}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
            {extra_fields.map((item, index) => {
              return (
                <div
                  className="complex-item-hor"
                  style={{
                    flex: 1,
                    minWidth: "50%",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    paddingRight: 6,
                    marginBottom: 8,
                  }}
                >
                  <span
                    style={{
                      width: 100,
                    }}
                  >
                    {item.name || item.index}:{" "}
                    {item.required ? (
                      <span
                        style={{
                          color: COLORS.danger_primary,
                        }}
                      >
                        *
                      </span>
                    ) : null}
                  </span>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  {this._renderFormItem(item)}
                </div>
              );
            })}

            {(validation.type == "datetime" || validation.type == "date") && (
              <div
                className="complex-item-hor"
                style={{
                  flex: 1,
                  minWidth: "50%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingRight: 6,
                  marginBottom: 8,
                }}
              >
                <span
                  style={{
                    width: 100,
                  }}
                >
                  Default:
                </span>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Checkbox
                  checked={validation.default}
                  onChange={(e) => {
                    this.props.onChange({
                      ...data,
                      validation: {
                        ...validation,
                        default: e.target.checked,
                      },
                    });
                  }}
                />
              </div>
            )}
            {(validation.type == "datetime" || validation.type == "date") && (
              <div
                className="complex-item-hor"
                style={{
                  flex: 1,
                  minWidth: "50%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingRight: 6,
                  marginBottom: 8,
                }}
              >
                <span
                  style={{
                    width: 100,
                  }}
                >
                  Format:
                </span>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Input
                  style={{ width: 200 }}
                  value={validation.format}
                  onChange={(e) => {
                    this.props.onChange({
                      ...data,
                      validation: {
                        ...validation,
                        format: e.target.value,
                      },
                    });
                  }}
                  placeholder={
                    validation.type == "datetime"
                      ? "%Y-%m-%d %H:%M"
                      : "%Y-%m-%d"
                  }
                />
              </div>
            )}
            {validation.type == "FK" && (
              <div
                className="complex-item-hor"
                style={{
                  flex: 1,
                  minWidth: "50%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingRight: 6,
                  marginBottom: 8,
                }}
              >
                <span
                  style={{
                    width: 100,
                  }}
                >
                  Validate:
                </span>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Checkbox
                  checked={validation.validate_fk}
                  onChange={(e) => {
                    this.props.onChange({
                      ...data,
                      validation: {
                        ...validation,
                        validate_fk: e.target.checked,
                      },
                    });
                  }}
                />
              </div>
            )}

            {validation.type == "FK" ||
              (validation.type == "list" && validation.list_type == "FK" && (
                <div
                  className="complex-item-hor"
                  style={{
                    flex: 1,
                    minWidth: "50%",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    paddingRight: 6,
                    marginBottom: 8,
                  }}
                >
                  <span
                    style={{
                      width: 100,
                    }}
                  >
                    Send Params:
                  </span>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <Checkbox
                    checked={validation.send_params}
                    onChange={(e) => {
                      this.props.onChange({
                        ...data,
                        validation: {
                          ...validation,
                          send_params: e.target.checked,
                        },
                      });
                    }}
                  />
                </div>
              ))}
            {validation.type == "FK" ||
              (validation.type == "list" && validation.list_type == "FK" && (
                <div
                  className="complex-item-hor"
                  style={{
                    flex: 1,
                    minWidth: "50%",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    paddingRight: 6,
                    marginBottom: 8,
                  }}
                >
                  <span
                    style={{
                      width: 100,
                    }}
                  >
                    Url:
                  </span>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <Input
                    style={{ width: 200 }}
                    value={validation.url}
                    onChange={(e) => {
                      this.props.onChange({
                        ...data,
                        validation: {
                          ...validation,
                          url: e.target.value,
                        },
                      });
                    }}
                    placeholder="/api"
                  />
                </div>
              ))}
            {validation.type == "string" && (
              <div
                className="complex-item-hor"
                style={{
                  flex: 1,
                  minWidth: "50%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingRight: 6,
                  marginBottom: 8,
                }}
              >
                <span
                  style={{
                    width: 100,
                  }}
                >
                  Min Length:
                </span>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <InputNumber
                  style={{ width: 200 }}
                  value={length.min}
                  onChange={(value) => {
                    this.props.onChange({
                      ...data,
                      validation: {
                        ...validation,
                        length: {
                          ...length,
                          min: value,
                        },
                      },
                    });
                  }}
                  placeholder="Min"
                />
              </div>
            )}
            {validation.type == "string" && (
              <div
                className="complex-item-hor"
                style={{
                  flex: 1,
                  minWidth: "50%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingRight: 6,
                  marginBottom: 8,
                }}
              >
                <span
                  style={{
                    width: 100,
                  }}
                >
                  Max Length:
                </span>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <InputNumber
                  style={{ width: 200 }}
                  value={length.max}
                  onChange={(value) => {
                    this.props.onChange({
                      ...data,
                      validation: {
                        ...validation,
                        length: {
                          ...length,
                          max: value,
                        },
                      },
                    });
                  }}
                  placeholder="Max"
                />
              </div>
            )}
            {validation.type == "string" && (
              <div
                className="complex-item-hor"
                style={{
                  flex: 1,
                  minWidth: "50%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingRight: 6,
                  marginBottom: 8,
                }}
              >
                <span
                  style={{
                    width: 100,
                  }}
                >
                  Strip:
                </span>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Checkbox
                  checked={validation.strip}
                  onChange={(e) => {
                    this.props.onChange({
                      ...data,
                      validation: {
                        ...validation,
                        strip: e.target.checked,
                      },
                    });
                  }}
                />
              </div>
            )}
            {validation.type == "choice" && (
              <div
                className="complex-item-hor"
                style={{
                  flex: 1,
                  // minWidth: 300,
                  minWidth: "50%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingRight: 6,
                  marginBottom: 8,
                }}
              >
                <span
                  style={{
                    width: 100,
                  }}
                >
                  Choice Type:
                </span>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Select
                  style={{
                    width: 200,
                  }}
                  placeholder="Choice Type"
                  value={validation.choice_type}
                  onChange={(value) => {
                    this.props.onChange({
                      ...data,
                      validation: {
                        ...validation,
                        choice_type: value,
                        choices: [],
                      },
                    });
                  }}
                >
                  {choice_options.map((item) => {
                    return (
                      <Select.Option key={item.value} value={item.value}>
                        {item.text}
                      </Select.Option>
                    );
                  })}
                </Select>
              </div>
            )}
            {validation.type == "choice" && validation.choice_type != null && (
              <div
                style={{
                  flex: 1,
                  // minWidth: 300,
                  minWidth: "100%",
                  display: "flex",
                  // flexDirection: 'row',
                  alignItems: "center",
                  padding: 8,
                  marginBottom: 8,
                  border: `1px solid ${COLORS.border_basic}`,
                  borderRadius: 10,
                }}
              >
                {/* <span style={{
                        width:100
                    }}>Schema:</span>&nbsp;&nbsp;&nbsp;&nbsp; */}
                <Form
                  form_style={{
                    width: "100%",
                  }}
                  forCreate={true}
                  initialData={validation}
                  parentData={validation}
                  submitted={false}
                  onChange={(schema_data) => {
                    // console.log("new schema data is", schema_data)
                    this.props.onChange({
                      ...data,
                      validation: {
                        ...validation,
                        ...schema_data,
                      },
                    });
                  }}
                  fields={choice_fields({
                    choice_type: validation.choice_type,
                  })}
                  submitting={false}
                  errorMessage={{}}
                  validationErrors={{}}
                />
              </div>
            )}
            {validation.type == "list" && (
              <div
                className="complex-item-hor"
                style={{
                  flex: 1,
                  // minWidth: 300,
                  minWidth: "50%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingRight: 6,
                  marginBottom: 8,
                }}
              >
                <span
                  style={{
                    width: 100,
                  }}
                >
                  List Type:
                </span>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Select
                  style={{
                    width: 200,
                  }}
                  placeholder="List Type"
                  value={validation.list_type}
                  onChange={(value) => {
                    this.props.onChange({
                      ...data,
                      validation: {
                        ...validation,
                        list_type: value,
                      },
                    });
                  }}
                >
                  <Select.Option key={"jsondata"} value={"jsondata"}>
                    Json Data
                  </Select.Option>
                  <Select.Option key={"string"} value={"string"}>
                    String
                  </Select.Option>
                  <Select.Option key={"FK"} value={"FK"}>
                    FK
                  </Select.Option>
                </Select>
              </div>
            )}

            {(validation.type == "jsondata" ||
              (validation.type == "list" &&
                validation.list_type == "jsondata")) && (
              <div
                style={{
                  flex: 1,
                  // minWidth: 300,
                  minWidth: "100%",
                  display: "flex",
                  // flexDirection: 'row',
                  alignItems: "center",
                  padding: 8,
                  marginBottom: 8,
                  border: `1px solid ${COLORS.border_basic}`,
                  borderRadius: 10,
                }}
              >
                {/* <span style={{
                        width:100
                    }}>Schema:</span>&nbsp;&nbsp;&nbsp;&nbsp; */}
                <Form
                  forCreate={true}
                  initialData={validation}
                  parentData={validation}
                  submitted={false}
                  onChange={(schema_data) => {
                    // console.log("new schema data is", schema_data)
                    this.props.onChange({
                      ...data,
                      validation: {
                        ...validation,
                        ...schema_data,
                      },
                    });
                  }}
                  fields={schema_field}
                  submitting={false}
                  errorMessage={{}}
                  validationErrors={{}}
                />
              </div>
            )}

            {(validation.type == "select" ||
              validation.type == "FK" ||
              validation.type == "choice" ||
              validation.type == "boolean") && (
              <div
                className="complex-item-hor"
                style={{
                  flex: 1,
                  // minWidth: 300,
                  minWidth: "50%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingRight: 6,
                  marginBottom: 8,
                }}
              >
                <span
                  style={{
                    width: 100,
                  }}
                >
                  Conditional:
                </span>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Checkbox
                  checked={validation.conditional}
                  onChange={(e) => {
                    this.props.onChange({
                      ...data,
                      validation: {
                        ...validation,
                        conditional: e.target.checked,
                        schema_options: {},
                      },
                    });
                  }}
                />
              </div>
            )}
            {validation.type == "select" && (
              <div
                style={{
                  flex: 1,
                  // minWidth: 300,
                  minWidth: "100%",
                  display: "flex",
                  // flexDirection: 'row',
                  alignItems: "center",
                  padding: 8,
                  marginBottom: 8,
                  border: `1px solid ${COLORS.border_basic}`,
                  borderRadius: 10,
                }}
              >
                <Form
                  form_style={{
                    width: "100%",
                  }}
                  forCreate={true}
                  initialData={validation}
                  parentData={validation}
                  submitted={false}
                  onChange={(schema_data) => {
                    // console.log("new schema data is", schema_data)
                    this.props.onChange({
                      ...data,
                      validation: {
                        ...validation,
                        ...schema_data,
                      },
                    });
                  }}
                  fields={string_option_field({
                    choice_type: validation.choice_type,
                  })}
                  submitting={false}
                  errorMessage={{}}
                  validationErrors={{}}
                />
              </div>
            )}
            {validation.conditional &&
              (validation.type == "FK" ||
                validation.type == "boolean" ||
                validation.type == "select" ||
                (validation.type == "choice" &&
                  validation.choice_type != null)) && (
                <div
                  style={{
                    flex: 1,
                    // minWidth: 300,
                    minWidth: "100%",
                    display: "flex",
                    // flexDirection: 'row',
                    alignItems: "center",
                    padding: 8,
                    marginBottom: 8,
                    border: `1px solid ${COLORS.border_basic}`,
                    borderRadius: 10,
                  }}
                >
                  <Form
                    form_style={{
                      width: "100%",
                    }}
                    forCreate={true}
                    initialData={{
                      schema_options_array: schema_options_array,
                    }}
                    parentData={{
                      schema_options_array: schema_options_array,
                    }}
                    submitted={false}
                    onChange={(_data) => {
                      let array_data = _data.schema_options_array || [];
                      // console.log("new schema data is",schema_options_array)

                      this.props.onChange({
                        ...data,
                        validation: {
                          ...validation,
                          schema_options: Object.assign(
                            {},
                            ...array_data.map((p) => ({
                              [p.value == null
                                ? validation.type == "boolean"
                                  ? false
                                  : true
                                : p.value]: p.schema,
                            }))
                          ),
                        },
                      });
                    }}
                    fields={conditional_field({
                      type:
                        validation.type == "choice"
                          ? validation.choice_type
                          : validation.type == "boolean"
                          ? "boolean"
                          : "string",
                      max: validation.type == "boolean" ? 2 : null,
                    })}
                    submitting={false}
                    errorMessage={{}}
                    validationErrors={{}}
                  />
                </div>
              )}

            {validation.type == "FK" && (
              <div
                style={{
                  flex: 1,
                  // minWidth: 300,
                  minWidth: "100%",
                  display: "flex",
                  // flexDirection: 'row',
                  alignItems: "center",
                  padding: 8,
                  marginBottom: 8,
                  border: `1px solid ${COLORS.border_basic}`,
                  borderRadius: 10,
                }}
              >
                <Form
                  form_style={{
                    width: "100%",
                  }}
                  forCreate={true}
                  initialData={{ extras: extra_data }}
                  parentData={{ extras: extra_data }}
                  submitted={false}
                  onChange={(schema_data) => {
                    // console.log("new schema data is", schema_data)
                    this.props.onChange({
                      ...data,
                      validation: {
                        ...validation,
                        ...schema_data.extras,
                      },
                    });
                  }}
                  fields={fk_extra_fields}
                  submitting={false}
                  errorMessage={{}}
                  validationErrors={{}}
                />
              </div>
            )}
          </div>
        ) : (
          <div className="json-editor-wrapper">
            <Editor
              mode={Editor.modes.code}
              value={data || {}}
              onChange={(value) => {
                console.log("change value is", value);

                this.props.onChange({
                  ...value,
                });
              }}
              className="small-json-editor"
              search={false}
              navigationBar={false}
              statusBar={false}
              ace={ace}
              // theme="ace/theme/github"
            />
          </div>
        )}
      </div>
    );
  }
}

export default ComplexConfigForm;
